import { render, staticRenderFns } from "./ProInputGroup.vue?vue&type=template&id=55f957fc&"
import script from "./ProInputGroup.vue?vue&type=script&lang=js&"
export * from "./ProInputGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports